import React from "react";
import '../../assets/css/admin/dashboardCSS/TitleBar.css';

const TitleBar = ({ title, subtitle, children }) => {
  return (
    <div className="dn-donations-header">
      <div>
        <h2 className="dn-donations-title">{title}</h2>
        <p className="dn-donations-subtitle">{subtitle}</p>
      </div>

      {/* Right side content (button etc) */}
      {children}
    </div>
  );
};

export default TitleBar;
